var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.preview || _vm.model
    ? _c(
        "div",
        { staticClass: "questionnaireEditQuestion", class: _vm.classes },
        [
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.leftClickHandler()
                },
                contextmenu: function ($event) {
                  $event.preventDefault()
                  return _vm.rightClickHandler()
                },
              },
            },
            [
              _c("label", { staticClass: "questionnaireEditQuestionLabel" }, [
                _c(
                  "span",
                  {
                    staticClass: "questionnaireEditQuestionLabelOrd",
                    class: {
                      locked: _vm.updatedTemplate.locked && !_vm.preview,
                    },
                  },
                  [_vm._v(_vm._s(_vm.updatedTemplate.ord) + ".")]
                ),
                _c("span", [_vm._v(_vm._s(_vm.updatedTemplate.name))]),
              ]),
              _vm.isList
                ? _c(
                    "div",
                    [
                      _vm._l(
                        _vm.updatedTemplate.options,
                        function (option, oIndex) {
                          return [
                            _c(
                              "label",
                              { key: oIndex, staticClass: "rbCheckbox" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "rbCheckboxLabel questionnaireEditQuestionListCheckbox",
                                  },
                                  [
                                    _vm._v(" " + _vm._s(option.label) + " "),
                                    _vm.isUserDefined
                                      ? _c("span", [
                                          _vm._v(
                                            "(" + _vm._s(option.value) + ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  )
                : _c("input", {
                    staticClass: "questionnaireEditQuestionInput",
                    attrs: { readonly: "readonly" },
                  }),
              _c("tooltip", {
                attrs: {
                  ord: _vm.updatedTemplate.ord,
                  title: _vm.updatedTemplate.name,
                  description: _vm.updatedTemplate.description,
                  "can-edit": !_vm.preview && !_vm.isUserDefined,
                  "is-edit-user-defined": !_vm.preview && _vm.isUserDefined,
                  locked: !!_vm.updatedTemplate.locked,
                  required: !!_vm.isRequired,
                  added: _vm.isAdded,
                },
              }),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }